var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-menu",
      attrs: { "data-test-id": "main-menu-container" }
    },
    _vm._l(_vm.mainMenu, function(item, index) {
      return _c("MenuItem", {
        key: index,
        class: [
          { "first-item": _vm.menuVisibleItemsCounter > 2 && index === 0 },
          {
            "last-item":
              _vm.menuVisibleItemsCounter > 2 &&
              index === _vm.mainMenu.length - 1
          }
        ],
        attrs: { item: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14cdb754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14cdb754","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/mainMenu/MainMenu.vue
// module id = Y5hn
// module chunks = 1